import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";
import { getCurrentCulture } from "@utils";

type AdministrationSideMenuItemLong = {
	path: string;
	translation: string;
	styling: string;
};

export default function AdministrationSideMenuItemLong(
	props: AdministrationSideMenuItemLong
) {
	const { path, translation, styling } = props;
	const pathLocation = useLocation();

	return (
		<li className="nav--secondary__item nav--account__item">
			<NavLink
				to={path}
				className="nav--secondary__link"
				activeClassName="is-selected"
				isActive={(_, location) => location.pathname.includes(styling)}
				title={translation}
			>
				<i
					className={classNames(
						`nav--secondary__icon u-icon u-icon--big u-icon--${styling}--alt`,
						{
							[`u-icon--${styling}--bold u-color--core--snow`]:
								pathLocation.pathname.includes(styling),
						}
					)}
				/>
				<div
					className={classNames("nav--secondary__title", {
						"is-long":
							translation?.length > 11 &&
							(getCurrentCulture() == "sv" ||
								getCurrentCulture() == "da"),
					})}
				>
					{translation}
				</div>
			</NavLink>
		</li>
	);
}
